import { CreateConstructionSiteClientFormData } from "../component/brokers/constructionSites/useCreateConstructionSiteForm";

export const buildConstructionSiteClientDto = (
	constructionSiteClientData: CreateConstructionSiteClientFormData & {
		isGFA?: boolean;
		brokerSocietyId?: number;
		actions?: unknown;
	},
) => {
	const {
		clientType,
		clientIsMOA,
		actions,
		...constructionSiteDataWithoutClientDetails
	} = constructionSiteClientData;

	const moaClientType =
		"moaClientType" in constructionSiteClientData
			? constructionSiteClientData.moaClientType
			: undefined;

	const {
		hasUserAccess,
		userAccess: _userAccess,
		...clientSocietyWithoutUserAccess
	} = "clientSociety" in constructionSiteClientData
		? constructionSiteClientData.clientSociety
		: {};

	return {
		...constructionSiteDataWithoutClientDetails,
		clientType,
		...(clientType === "USER"
			? { clientUsers: constructionSiteClientData.clientUsers }
			: hasUserAccess === "true"
				? { clientSociety: constructionSiteClientData.clientSociety }
				: {
						clientSociety: { ...clientSocietyWithoutUserAccess, hasUserAccess },
					}),
		moaClientType: clientIsMOA === "true" ? clientType : moaClientType,
		clientIsMOA,
		...(clientIsMOA === "true"
			? {}
			: moaClientType === "USER"
				? {
						moaClientUser:
							"moaClientUser" in constructionSiteClientData
								? constructionSiteClientData.moaClientUser
								: undefined,
					}
				: {
						moaClientSociety:
							"moaClientSociety" in constructionSiteClientData
								? constructionSiteClientData.moaClientSociety
								: undefined,
					}),
		...(actions ? { actions } : {}),
	};
};
